












































import Vue from 'vue';
import TertiaryButton from '@/components/common/buttons/TertiaryButton.vue';
import CTAButton from '@/components/common/buttons/CTAButton.vue';
import PlusIcon from '../../assets/img/plus.svg';
import LogoutButton from '@/components/common/buttons/LogoutButton.vue';
import TextButton from '@/components/common/buttons/TextButton.vue';
import { createNamespacedHelpers } from 'vuex';
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
const mapSessionActions = createNamespacedHelpers('session').mapActions;
const mapSessionState = createNamespacedHelpers('session').mapState;
export default Vue.extend({
    components: { TextButton, LogoutButton, CTAButton, TertiaryButton, PlusIcon },
    computed: {
        ...mapCustomLabelsState(['createGrievanceTitle', 'accessGrievanceBtn', 'viewGrievance']),
        ...mapSessionState(['portalAccessToken']),
    },
    methods: {
        ...mapSessionActions(['logOut']),
    },
});
